<template>
	<div class="lead-lockup">
		<div class="lead-lockup__lead__container">
			<h2 class="lead-lockup__lead">{{ lead }}</h2>
			<slot name="leadContext"></slot>
		</div>
		<div class="lead-lockup__context">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		lead: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.lead-lockup {
	margin-bottom: var(--size-base);
	color: var(--gray-800);

	&__lead__container {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__lead {
		font-size: 18px;
		font-weight: 600;
		margin: 0;
	}

	&__context {
		font-size: var(--size-base);
		color: var(--gray-600);

		> * {
			margin: 0;
		}
	}
}
</style>
